// extracted by mini-css-extract-plugin
export var addressFields = "_mc-0";
export var animationContainer = "_mc-1";
export var footer = "_mc-2";
export var lineItems = "_mc-3";
export var modalContent = "_mc-4";
export var orderName = "_mc-5";
export var strong = "_mc-6";
export var warning = "_mc-7";